import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { animate, style, transition, trigger } from "@angular/animations";
import { ToastController, ViewWillEnter } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { AppService } from "src/app/_services/app.service";
import { AuthService } from "src/app/_services/auth.service";
import { DevModeService } from "src/app/_services/dev-mode.service";
import { MessagesService } from "src/app/_services/messages.service";
import { NavigationService } from "src/app/_services/navigation-service.service";
import { NotificationsService } from "src/app/_services/notifications.service";
import { ProviderService } from "src/app/_services/provider.service";
import { PusherService } from "src/app/_services/pusher.service";
import { PusherBackgroundService } from "src/app/_services/pusher-background.service";
import { BackgroundLocationService } from "../../_services/background-location.service";
import { GeoLocationService } from "../../_services/geoLocation.service";
import { LocalStorageService } from "../../_services/localStorage.service";

@Component({
  selector: "app-profile-menue",
  templateUrl: "./profile-menue.component.html",
  styleUrls: ["./profile-menue.component.scss"],
  standalone: false,
  animations: [
    trigger("slideInLeft", [
      transition(":enter", [
        style({ transform: "translateX(-20px)", opacity: 0 }),
        animate("220ms ease-out", style({ transform: "translateX(0)", opacity: 1 })),
      ]),
    ]),
  ],

})
export class ProfileMenueComponent implements OnInit, OnDestroy, ViewWillEnter {
  user: any;
  role: any;
  transporterServiceAvailable: boolean = false;
  unreadConversations: number = 0;
  transporterStatus: any = false;
  loadingTransporterData: boolean = false;
  showModalTransporterSuccess: boolean = false;
  TransporterSuccessSubscription!: Subscription;
  clientMenu: any = [];
  prestaMenu: any = [];
  completition = 0;
  showTooltip = false;
  activeAccount = false;
  current_demands_count: number = 0;
  undreaded_messages_count: number = 0;
  undreaded_admin_messages_count: number = 0;
  unreadNotificationsCount: number = 0;
  Math = Math;
  constructor(
    private localStorageServices: LocalStorageService, private translate: TranslateService, private providerService: ProviderService,
    private geoLocationService: GeoLocationService,
    private backgroundLocationService: BackgroundLocationService,
    private messagesService: MessagesService, private authService: AuthService, private appService: AppService,
    private pusherService: PusherService,
    private pusherBackgroundService: PusherBackgroundService,
    private navigationService: NavigationService,
    private notificationsService: NotificationsService,
    private changeDetectorRef: ChangeDetectorRef,
    private devModeService: DevModeService,
    private toastController: ToastController,
  ) {
    this.user = this.localStorageServices.getUserData();
    this.role = this.localStorageServices.getUserRole();
    this.subscribeHomeData();
    if (this.role === "prestataire") {
      this.subscribeToWorkFinishedModal();
    }
    this.clientMenu = [
      {
        image: "../../../assets/icon/icone-profile/menu-icons-v2/Profile.svg",
        label: this.translate.instant("MENU.MY_PROFILE"),
        class: "profile",
        click: () => {
          this.goTo("profile");
        },
      },
      {
        image: "../../../assets/icon/icone-profile/menu-icons-v2/Notif.svg",
        label: this.translate.instant("MENU.MY_NOTIFICATIONS"),
        class: "notifications",
        click: () => {
          this.goTo("notifications");
        },
      },
      {
        image: "../../../assets/icon/icone-profile/menu-icons-v2/Config.svg",
        label: this.translate.instant("CONGIGURATION_PAGE.REGLAGES"),
        class: "configurations",
        click: () => {
          this.goTo("configurations");
        },
      },
      {
        image: "../../../assets/icon/icone-profile/menu-icons-v2/Contact.svg",
        label: this.translate.instant("MENU.CONTACT_US"),
        class: "contact",
        click: () => {
          this.goTo("contact");
        },
      },
      {
        image:
          "../../../assets/icon/icone-profile/menu-icons-v2/Deconnect.svg",
        label: this.translate.instant("MENU.DECONNECT"),
        class: "logout",
        click: () => {
          this.logout();
        },
      },
    ];
    this.prestaMenu = [
      {
        image: "../../../assets/icon/icone-profile/menu-icons-v2/Messages.svg",
        label: this.translate.instant("MENU.MY_MESSAGES"),
        class: "messages",
        click: () => {
          this.goTo("messagerie");
        },
      },
      {
        image: "../../../assets/icon/icone-profile/menu-icons-v2/Profile.svg",
        label: this.translate.instant("MENU.MY_PROFILE"),
        class: "profile",
        click: () => {
          this.goTo("profile");
        },
      },
      {
        image:
          "../../../assets/icon/icone-profile/menu-icons-v2/FilledWallet.svg",
        label: this.translate.instant("MENU.MY_WALLET"),
        class: "cards",
        click: () => {
          this.goTo("monnaie");
        },
      },
      {
        image: "../../../assets/icon/icone-profile/menu-icons-v2/Notif.svg",
        label: this.translate.instant("MENU.MY_NOTIFICATIONS"),
        class: "notifications",
        click: () => {
          this.goTo("notifications");
        },
      },
      {
        image: "../../../assets/icon/icone-profile/menu-icons-v2/Config.svg",
        label: this.translate.instant("CONGIGURATION_PAGE.REGLAGES"),
        class: "configurations",
        click: () => {
          this.goTo("configurations");
        },
      },
      {
        image: "../../../assets/icon/icone-profile/menu-icons-v2/Contact.svg",
        label: this.translate.instant("MENU.CONTACT_US"),
        class: "contact",
        click: () => {
          this.goTo("contact");
        },
      },
      {
        image:
          "../../../assets/icon/icone-profile/menu-icons-v2/Deconnect.svg",
        label: this.translate.instant("MENU.DECONNECT"),
        class: "logout",
        click: () => {
          this.logout();
        },
      },
    ];
  }
  ionViewWillEnter(): void {
    this.authService.getCompletetion(this.role).subscribe((res: any) => {
      this.appService.setUserCompletion(res.body.profile_completion);
    });
  }
  ngOnDestroy(): void {
    this.TransporterSuccessSubscription &&
      this.TransporterSuccessSubscription.unsubscribe();
  }
  subscribeHomeData() {
    this.appService.homeDataObservable().subscribe((data: any) => {
      if (data) {
        const {
          current_demands_count,
          undreaded_messages_count,
          undreaded_admin_messages_count,
        } = data;
        this.undreaded_messages_count = undreaded_messages_count ?? 0;
        this.current_demands_count = current_demands_count ?? 0;
        this.undreaded_admin_messages_count =
          undreaded_admin_messages_count ?? 0;
        this.updateUnreadNotificationsFromHomeData(data);
      }
    });
  }

  ngOnInit() {
    const statutPro = this.localStorageServices.getActiveStatus();
    this.activeAccount = statutPro === "ACTIVE" ? true : false;
    this.getUnreadConversations();
    this.loadUnreadNotificationsCount();
    this.appService.userCompletionObservable().subscribe({
      next: (res: any) => {
        this.completition = res;
        this.changeDetectorRef.detectChanges();
      }, error: (error: any) => { }
    });
  }

  initTransporterData() {
    let state = this.appService.getTransporterDate();
    if (!state) {
      state = this.localStorageServices.getTransporterDate();
    } else {
      return;
    }
    this.appService.dispatchdata("TRANSPORTER_DATA", state);
  }

  openTransporterPage() {
    this.navigationService.navigateTo("prestataire/transporter");
  }
  subscribeToWorkFinishedModal() {
    this.TransporterSuccessSubscription = this.appService
      .workFinishedModalObservable()
      .subscribe((res: any) => {
        this.showModalTransporterSuccess = res;
      });
  }
  getUnreadConversations() {

    this.appService.homeDataObservable().subscribe((data) => {
      this.undreaded_admin_messages_count = data.undreaded_admin_messages_count;
      this.unreadConversations = data.undreaded_messages_count;
    })
  }

  private updateUnreadNotificationsFromHomeData(data: any) {
    const count =
      data?.unread_notifications_count ??
      data?.undreaded_notifications_count ??
      data?.notifications_unread_count;

    if (typeof count === "number") {
      this.unreadNotificationsCount = Math.max(0, count);
    }
  }

  private loadUnreadNotificationsCount() {
    const userId = this.user?.client?.id;
    if (!userId) {
      this.unreadNotificationsCount = 0;
      return;
    }

    this.notificationsService
      .getAllNotifications({ "user_ids[]": userId })
      .subscribe({
        next: (res: any) => {
          const notifications = Array.isArray(res?.body?.data) ? res.body.data : [];
          this.unreadNotificationsCount = notifications.filter((item: any) => this.isUnreadNotification(item)).length;
        },
        error: () => {
          this.unreadNotificationsCount = 0;
        },
      });
  }

  private isUnreadNotification(item: any): boolean {
    if (item && typeof item.is_read !== "undefined") {
      return Number(item.is_read) === 0;
    }
    if (item && "read_at" in item) {
      return item.read_at == null;
    }
    return false;
  }
  goTo(path: string) {
    let baseUrl = "";
    switch (this.role) {
      case "client":
        baseUrl = "particulier";
        break;
      case "prestataire":
        baseUrl = "prestataire";
        break;
      default:
        baseUrl = "particulier";
        break;
    }
    // Use NavigationService instead of navController
    this.navigationService.navigateTo("/" + baseUrl + "/" + path);
  }
  logout() {
    this.authService.logout().subscribe();
    this.pusherService.disconnectAndReset();
    this.geoLocationService.stopTracking();
    this.backgroundLocationService.stopTracking().catch(() => {});
    // Live Activity iOS : terminer la carte lockscreen — sinon elle reste
    // affichée jusqu'au staleDate (8h) avec une session déconnectée.
    this.pusherBackgroundService.endLiveActivity().catch(() => {});
    this.goTo("");
    this.localStorageServices.logout();
  }
  prestataireDemands() {
    let auth = this.localStorageServices.getToken();
    if (auth) {
      this.providerService.getAssignedDemand().subscribe((res: any) => {
        if (res.body) {
          const data = res.body;
          data.success && this.providerService.storeDemandData(data);
          data.success && this.localStorageServices.setCurrentDemand(data);
          data.success && this.navigationService.navigateTo("prestataire/demandes");
        } else if (res.error) {
        }
      });
    } else {
      this.navigationService.goToLogin();
    }
  }

  toggleTooltip(event: any) {
    event.stopPropagation();
    this.showTooltip = !this.showTooltip;
  }

  /**
   * Hidden dev-mode unlock — Android-style 7-tap on the logo. Counts taps in
   * a 3s rolling window; reveals the Log Viewer toggle in Configurations
   * once activated.
   */
  onLogoTap(): void {
    const result = this.devModeService.registerLogoTap();
    if (result.justUnlocked) {
      // Show the success toast EXACTLY once, on the crossing tap.
      this.presentDevToast("Mode développeur activé. Voir Configurations.", "success");
      return;
    }
    if (result.unlocked) {
      // Already on for a while — stay silent, no toast spam on every logo tap.
      return;
    }
    if (result.remainingTaps <= 3) {
      // Discreet hint when approaching unlock — mirrors Android behavior.
      this.presentDevToast(`Plus que ${result.remainingTaps} appui(s)…`, "medium");
    }
  }

  private async presentDevToast(message: string, color: string): Promise<void> {
    const toast = await this.toastController.create({
      message,
      duration: 1400,
      position: "bottom",
      color,
    });
    await toast.present();
  }
}
